
import type { PropType } from 'vue'
import { defineComponent } from 'vue'

import useTooltip from '@/modern/composable/useTooltip'

export default defineComponent({
    props: {
        component: {
            type: String as PropType<'router-link' | 'a'>,
            default: 'router-link'
        },
        opened: {
            type: Boolean,
            default: true,
        },
    },
    setup(props) {
        const { reference, tooltip, isVisible, x, y, strategy, open, close } = useTooltip({
            placement: 'right-end',
            strategy: 'absolute',
            offset: 12,
            autoPlacement: {
                allowedPlacements: ['right-end'],
            },
        })

        const onOpenTooltip = () => {
            if (!props.opened) {
                open()
            }
        }
        
        return {
            reference,
            tooltip,
            isVisible,
            x,
            y,
            strategy,
            onOpenTooltip,
            close
        }
    }
})
